import Seo from "@/components/feature/Seo";
import LegalBody, { type LegalSection } from "@/pages/legal/components/LegalBody";

const sections: LegalSection[] = [
  {
    heading: "1. What Cookies Are",
    paragraphs: [
      "Cookies are small text files stored by your browser. They help websites function correctly and can help understand how a site is used.",
    ],
  },
  {
    heading: "2. How This Website Uses Cookies",
    paragraphs: [
      "This website may use essential cookies required for basic functionality. Where analytics are enabled, they are used in aggregate to understand how visitors use the site so it can be improved.",
    ],
  },
  {
    heading: "3. Managing Cookies",
    paragraphs: [
      "You can control or delete cookies through your browser settings. Disabling essential cookies may affect how parts of the website work.",
    ],
  },
  {
    heading: "4. Third-Party Services",
    paragraphs: [
      "If third-party services such as analytics are enabled, they may set their own cookies. Their use of information is governed by their respective policies.",
    ],
  },
  {
    heading: "5. Updates",
    paragraphs: [
      "This cookie policy may be updated. The latest version will always be available on this page.",
    ],
  },
];

export default function CookiePolicy() {
  return (
    <>
      <Seo
        title="Cookie Policy | KAL LORDS ZERO21 DJT"
        description="How the KAL LORDS ZERO21 DJT website uses cookies and how you can manage them in your browser."
        path="/cookie-policy"
      />
      <LegalBody
        breadcrumb="Cookie Policy"
        title="Cookie Policy"
        description="This policy explains how cookies are used on this website and how you can manage them."
        updated="September 2026"
        sections={sections}
      />
    </>
  );
}